import React from 'react';
import PropTypes from 'prop-types';
import { GridList, GridListTile } from '@material-ui/core';
import NetworkPhoto from '../../../components/NetworkPhoto';

const PhotosTakenToday = ({ photos, selectPhoto }) => {
  const openPhoto = (event, photo) => {
    event.preventDefault();
    event.stopPropagation();

    selectPhoto(photo);
  };

  return (
    <GridList
      cellHeight={40}
      cols={3.5}
      style={{ flexWrap: 'nowrap', width: 280 }}
    >
      { photos.map((photo, index) => (
        <GridListTile cols={1} key={index}>
          <div className='flex-columns flex-1' onClick={event => openPhoto(event, photo)}>
            <NetworkPhoto
              source={photo.image}
              height={40}
            />
          </div>
        </GridListTile>
      ))}
    </GridList>
  );
};

PhotosTakenToday.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.shape({
    child_group_image_id: PropTypes.number,
    child_id: PropTypes.number,
    created_at: PropTypes.string,
    group_image_id: PropTypes.number,
    image: PropTypes.string,
    key: PropTypes.string
  })),
  selectPhoto: PropTypes.func
};

export default PhotosTakenToday;
